import { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  label: string;
  value: ReactNode;
  icon: ReactNode;
  tone?: 'default' | 'brand';
}

export function KpiCard({ label, value, icon, tone = 'default' }: Props) {
  return (
    <div
      className={clsx(
        'rounded-2xl border p-4',
        tone === 'brand'
          ? 'border-brand-800/40 bg-brand-900/20'
          : 'border-border bg-surface',
      )}
    >
      <div
        className={clsx(
          'mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide',
          tone === 'brand' ? 'text-brand-400' : 'text-text-muted',
        )}
      >
        {icon}
        {label}
      </div>
      <div className="text-2xl font-bold text-text-primary">{value}</div>
    </div>
  );
}
